import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
 const [isDark, setIsDark] = useState(() => {
  const saved = localStorage.getItem('tradeengine-theme');

  if (saved) {
    return saved === 'dark';
  }

  // Detect browser default theme
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
});

  useEffect(() => {
    localStorage.setItem('tradeengine-theme', isDark ? 'dark' : 'light');
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  const toggleTheme = () => setIsDark(!isDark);

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};
